import { ListPrenotatiProveFinaliDTO } from './../../../model/newModel';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  EliminaCommand,
  SearchPrenotatiProvaFinaleCommand,
} from 'src/app/model/command-model';

@Injectable({
  providedIn: 'root',
})
export class PrenotazioniEsamiService {
  constructor(private http: HttpClient) {}

  delete(id: number) {
    const command = new EliminaCommand();
    command.id = id;
    return this.http.post<ListPrenotatiProveFinaliDTO>(
      ConstantsCLA.ELIMINA_URL,
      command
    );
  }

  search(idStudente: number) {
    const command = new SearchPrenotatiProvaFinaleCommand();
    command.skip = 0;
    command.take = 10;
    command.idStudente = idStudente;
    return this.http.post<ListPrenotatiProveFinaliDTO>(
      ConstantsCLA.SEARCH_URL,
      command
    );
  }
}
